/**
 * @fileoverview Month title, today control, and confirm button for CustomCalendar.
 * @module components/CustomCalendar/CustomCalendarHeader
 */
import styles from "./CustomCalendar.module.css";
import { ReactComponent as ConfirmIcon } from "../../assets/icons/BusinessEvents/ConfirmIcon.svg";

const CustomCalendarHeader = ({
  monthDisplay,
  onToday,
  showConfirmButton,
  isConfirmButtonDisabled,
  onConfirm,
  t,
}) => (
  <div className={styles.header}>
    <div className={styles.titleSection}>
      <h2 className={styles.title}>{monthDisplay}</h2>
      <button className={styles.todayButton} onClick={onToday}>
        {t("pages.viewAppointments.today")}
      </button>
    </div>
    {showConfirmButton && (
      <div className={styles.confirmButtonSection}>
        <button
          className={`${styles.confirmButton} ${
            isConfirmButtonDisabled ? styles.disabled : ""
          }`}
          onClick={onConfirm}
          disabled={isConfirmButtonDisabled}
        >
          <ConfirmIcon className={styles.confirmIcon} />
          <span className={styles.confirmText}>{t("common.confirm")}</span>
        </button>
      </div>
    )}
  </div>
);

export default CustomCalendarHeader;
